import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';

export interface BridgeLandingPageProps {}

export const BridgeLandingPage = ({}: BridgeLandingPageProps) => {
    return (
        <>
            <SectionHeaderBar title={'Bridge'}></SectionHeaderBar>
        </>
    );
};
